import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {createLogoutRequest} from "../../actions/logoutAction";
import { sendFriendRequest, respondTorequest, unfriendRequest, cancelfriendRequest, requestSearchFriend} from "../../actions/friendAction";
import {getNotificationCount, getNotificationlist, updateReadNotification, getFriendNotificationlist} from "../../actions/notificationAction";
import { encrypt } from "../../helpers/CryptoJs";
import iconPath from "../../helpers/iconHelper";
import { getlanguagelist } from "../../helpers/changelanguage";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Remainingpromotion from "../Promotion/PromotionBody/remainingpromotion";
import Addbox from "../FeedContainer/Addbox";
import PromotionHeader from "../Promotion/PromotionHeader"
import "./search.css";
import $ from 'jquery'

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userImage              : '',
      userName               : '',
      userMembership         : '',
      userId                 : '',
      isToggle               : false,
      friend_notification    : 0,
      other_notification     : 0,
      total_notifiaction     : 0,
      chat_notification      : 0,
      groupchat_notification : 0,
      notifications          : [],
      notificationsfriend    : [],
      searchresultlist       : [],
      is_open                : 'none',
      is_spin                : 'fa-spin',
      pagination             : 0,
      is_open_friend         : 'none',
      is_spin_friend         : 'fa-spin',
      pagination_friend      : 0,
      search_name            : '',
      is_open_search         : 'none',
      openDialog             : false,
      serch_sel_frndid       : 0,
      serch_sel_frndstatus   : null,
     };

    this.logout             = this.logout.bind(this);
    this.toggleDiv          = this.toggleDiv.bind(this);
    this.viewChat           = this.viewChat.bind(this);
    this.showNotification   = this.showNotification.bind(this);
    this.showNotificationFriend = this.showNotificationFriend.bind(this);
    this.chk_scroll         = this.chk_scroll.bind(this);
    this.reDirection        = this.reDirection.bind(this);
    this.chk_scroll_friend  = this.chk_scroll_friend.bind(this);
    this.handleChange       = this.handleChange.bind(this);
    this.sendFriendRequest  = this.sendFriendRequest.bind(this);
    this.handleClose        = this.handleClose.bind(this);
  }
  componentDidMount(){
   this.props.getNotificationCount();
   $('#notify_ul').bind('scroll',this.chk_scroll);
   $('#notify_friend_ul').bind('scroll',this.chk_scroll_friend);
  
  
    this.setState({
      userName       : this.props.currentUserDetails.user.first_name,
      userImage      : this.props.currentUserDetails.user.image,
      userId         : this.props.currentUserDetails.user.id,
      userMembership : this.props.currentUserDetails.user.membership,
      toggle_menu    : ''
    })
  }
  chk_scroll(e){
    var elem = $(e.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
    { 
      this.setState({
        is_spin_friend : 'fa-spin',
        pagination : this.state.pagination + 1
      },function(){
        this.props.getNotificationlist(this.state.pagination);  
      })
      
    }
  }

  chk_scroll_friend(e){
    var elem = $(e.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
    { 
      this.setState({
        is_spin_friend : 'fa-spin',
        pagination_friend : this.state.pagination_friend + 1
      },function(){
        this.props.getFriendNotificationlist(this.state.pagination_friend);  
      })
      
    }
  }

  reDirection(obj){
     let param = {
      id            : obj.id,
      content_type  : obj.content_type,
      content_id    : obj.content_id,
      link          : obj.link,
      link_type     : obj.link_type,
    }
    this.props.updateReadNotification(param); 
  }
  UNSAFE_componentWillReceiveProps(nextProps){ 
  
    if(this.props.respondtorequest != nextProps.respondtorequest){
      ToastsStore.success(`Friend request ${nextProps.respondtorequest.status}`);

      
        $("#serchpage_img_"+nextProps.respondtorequest.searchrow_id).attr('src',nextProps.respondtorequest.status == 'ACCEPTED' ? iconPath['FRIEND'] : iconPath['ADDFRIEND']);
        $("#serchpage_status_"+nextProps.respondtorequest.searchrow_id).html(nextProps.respondtorequest.status == 'ACCEPTED' ? 'ACCEPTED' : 0);
        this.setState({ openDialog : false })
     
      
    }else if(this.props.unfriendrequest != nextProps.unfriendrequest){
      $("#serchpage_img_"+nextProps.unfriendrequest.searchrow_id).attr('src',iconPath['ADDFRIEND']);
      $("#serchpage_status_"+nextProps.unfriendrequest.searchrow_id).html(0);
      ToastsStore.success(`UnFriend`);
     
    }else if(this.props.cancelfriendrequest != nextProps.cancelfriendrequest){
      $("#serchpage_img_"+nextProps.cancelfriendrequest.searchrow_id).attr('src',iconPath['ADDFRIEND']);
      $("#serchpage_status_"+nextProps.cancelfriendrequest.searchrow_id).html(0);
      ToastsStore.success('Cancel request');
     
    }else if(this.props.sendfriendrequest != nextProps.sendfriendrequest){
      $("#serchpage_img_"+nextProps.sendfriendrequest.searchrow_id).attr('src',iconPath['PENDINGFRIEND']);
      $("#serchpage_status_"+nextProps.sendfriendrequest.searchrow_id).html('PENDING');
      ToastsStore.success('Friend request send');
    }
  
  }
  toggleDiv(){
    this.setState({isToggle: !this.state.isToggle});
  }
  logout() {
    this.props.createLogoutRequest(this.state);
  }
  showNotification(){
    this.setState({
      is_open       : (this.state.is_open == 'none') ? "block" : 'none'
    },function(){
      if(this.state.is_open == 'block'){
        this.props.getNotificationlist(0);
      }
    });
   
  }

  showNotificationFriend(){
    this.setState({
      is_open_friend       : (this.state.is_open_friend == 'none') ? "block" : 'none'
    },function(){
      if(this.state.is_open_friend == 'block'){
        this.props.getFriendNotificationlist(0);
      }
    });
   
  }

  respondtorequest(status,friendId){
    let param = {
      sender_id : (friendId === undefined) ? this.state.serch_sel_frndid : friendId,
      status    : status
    };
    this.props.respondTorequest(param);
  }

  viewChat(){
    this.props.history.push(`/chat/0`);
  }

  handleChange(e) {
    if(e.target.name == "search_name"){
      this.setState({
        [e.target.name]: e.target.value,
      },function(){
        if(this.state.search_name.length >= 3){
          let param = {
            search_param : this.state.search_name
          };
          this.props.requestSearchFriend(param);
        }else if(this.state.search_name.length == 0){
          this.setState({
            is_open_search : 'none'
          })
        }
      });
    }
  }
  sendFriendRequest(id){

    let friendstatus = $("#serchpage_status_"+id).html();
    if(friendstatus == 'PENDING'){
      //cancel
      this.props.cancelfriendRequest({receiver_id : id});
    }else if(friendstatus == 'ACCEPTED') {
      //unfriend
      this.props.unfriendRequest({friend_id : id});
    }else if(friendstatus == 'PENDING RECEIVER'){
      //ACCECPT or DECLINE
      this.handleClose(id);
    }else{
      //send request
      this.props.sendFriendRequest(id);
    }
      
  }
  handleClose(id){
    this.setState({
      serch_sel_frndid : id,
      openDialog       : this.state.openDialog === true ? false : true
    })
  }

  render() {
  
    let  languagelist           = getlanguagelist();
    let  searchresultlist       = this.props.searchresult || [];
    let search_name             = localStorage.getItem('search_name');

    return (
      <div>
        <div className="container">
          <div className="col-lg-12">
            <PromotionHeader />
           {/*  <div className="cover_pic">
              <img className="user gold_user" src="http://res.cloudinary.com/www-baaldahab-com/image/upload/q_auto:low/v1523027272/uploads/6/upload_image_path/debnath_tuptup_1574927866702.jpg" />
              <h2>DEBNATH TUPTUP </h2>
              <span>Tayeglo, Somalia</span>
            </div> */}
          </div>
        </div>
        <div className="container">
                <div className="clr20"/>
                <div className="searchsec  col-lg-12">
                  <div className="post_box">
                    <div className="search-header">
                      <label className="search_label">{languagelist.finding_result_for} <b style={{color : '#4189DD'}}>{search_name}</b></label>
                      <select className="form-control search_dropdown" name="search" readOnly>
                            <option value="PEOPLE" >{languagelist.people}</option>
                        </select>
                    </div>
                  </div>
                </div>
                  <div class="col-lg-12 search-result-title"><h2>Search Results</h2></div>
                  <div className="content_area search-result">
                    
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
                        <div className="row margin-row">
                          <Remainingpromotion />
                          <Addbox />
                        </div>
                    </div>
                    <div className="col-lg-9">
                     
                      <div className="post_box">
                          <div className="search">
                            <ul>
                            { 
                              (searchresultlist.length > 0) ? 
                              searchresultlist.map((notify,index) => {
                                
                                return (
                                  
                                  <li key={index} >
                                      <img src = {notify.image} 
                                          alt={notify.full_name}
                                          onError = {(e) => {
                                            e.target.src = iconPath['DEFAULTUSER']
                                          }} 
                                          className={(notify.membership == 'GOLD') ? "gold_user notify_user" : "notify_user"} 
                                      /> 
                                      <div className="notify_detail">
                                          <strong><Link to={`/user/${encrypt(notify.id)}`}>{notify.full_name}</Link></strong>
                                          <span>{notify.state}, {notify.country_name}</span>
                                            
                                      </div> 
                                      <span id={`serchpage_status_${notify.id}`} style={{display : 'none'}}>{notify.already_friend}</span>
                                    
                                      <a href={void(0)} onClick={()=>this.sendFriendRequest(notify.id)}>
                                        
                                        {(notify.already_friend == 'ACCEPTED')  ? 
                                          <img src={iconPath['FRIEND']} id={`serchpage_img_${notify.id}`} className="friend-icon"/>
                                          :
                                          ((notify.already_friend == 'PENDING RECEIVER') || (notify.already_friend == 'PENDING')) ? 
                                          <img src={iconPath['PENDINGFRIEND']} id={`serchpage_img_${notify.id}`} className="friend-icon"/>
                                            : <img src={iconPath['ADDFRIEND']} id={`serchpage_img_${notify.id}`} className="friend-icon"/>
                                        }
                                      </a>
                                          
                                      <div className="clearfix"></div>
                                  </li>
                                  
                                )
                              
                              })
                              : null
                              }

                    <Dialog
                      open={this.state.openDialog}
                      onClose={this.handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogActions>
                        <Button onClick={()=>this.respondtorequest('ACCEPTED')} color="primary">
                          ACCEPT
                        </Button>
                        <Button onClick={()=>this.respondtorequest('DECLINE')} color="secondary" autoFocus>
                          DECLINE
                        </Button>
                      </DialogActions>
                    </Dialog>
                                          
                            </ul>
                        </div>
                      </div>
                    </div>
                </div>
            
        </div>
      </div>
    );
  };
}
const mapStateToProps = state => {
  return {currentUserDetails  : state.login,
          loggedOutUser       : state.logout.loggedUser,
          notificationCount   : state.countnotification.notificationCounter,
          chatcounter         : state.chatuserlist.chatList.chat_counter, 
          notifications       : state.notificationlist.notificationList.details, 
          read                : state.readnotification.readNotification,
          notificationsfrnd   : state.friendnotificationlist.friendnotificationList.details, 
          respondtorequest    : state.requestrespond.requestRespond,
          searchresult        : state.searchfriend.searchFriend,
          sendfriendrequest   : state.friendrequest.friendRequest,
          unfriendrequest     : state.unfriendrequest.requestUnfriend,
          cancelfriendrequest : state.requestcancel.requestCancel,
         }
}
const mapDispatchToProps = dispatch => {
  return {
    createLogoutRequest       : bindActionCreators(createLogoutRequest, dispatch),
    getNotificationCount      : bindActionCreators(getNotificationCount, dispatch),
    getNotificationlist       : bindActionCreators(getNotificationlist, dispatch),
    updateReadNotification    : bindActionCreators(updateReadNotification, dispatch),
    getFriendNotificationlist : bindActionCreators(getFriendNotificationlist, dispatch),
    respondTorequest          : bindActionCreators(respondTorequest, dispatch),
    sendFriendRequest         : bindActionCreators(sendFriendRequest, dispatch),
    unfriendRequest           : bindActionCreators(unfriendRequest, dispatch),
    cancelfriendRequest       : bindActionCreators(cancelfriendRequest, dispatch),

  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));